<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <StudioCheckout>
          <template v-slot:breadcrumbs="props">
            <div class="small">
              <div class="d-flex">
                <span
                  class="back-button pointer d-md-none"
                  @click="$router.go(-1)"
                >
                  <i class="fal fa-chevron-left"></i>
                </span>
                <StudioLogo class="logo-image mb-2" :studio="studio" />
              </div>
              <hr class="d-block d-md-none mt-2 mb-3 p-0" />
              <router-link :to="{ name: 'studio-product' }" class="c-coral">
                <span>
                  {{ props.product.product_name }}
                </span>
              </router-link>
              <span class="mx-2 mx-md-3"
                ><i class="fal fa-chevron-right"></i
              ></span>
              <span class="c-charcoal">{{
                $t('STUDIO.LABELS.BREADCRUMB_CHECKOUT')
              }}</span>
            </div>
          </template>
        </StudioCheckout>
      </div>
    </div>
  </div>
</template>

<script>
import StudioCheckout from '@/web/components/checkout/StudioCheckout';
import StudioLogo from '@/web/components/navigation/StudioLogo';
import { mapGetters } from 'vuex';

export default {
  name: 'StudioProductCheckout',
  components: {
    StudioCheckout,
    StudioLogo,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.logo-image {
  display: block;
  height: 60px;
  width: auto;
}

.back-button {
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-left: -10px;
}
</style>
